{
  "backButton": "Vend tilbage til {prevMenuButton}",
  "moreActions": "Flere handlinger",
  "unavailable": "Ikke tilgængelig, udvid for detaljer"
}
